import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  align-self: center;
  justify-self: center;
`;

export const NoReservationHeader = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  text-align: center;
`;

export const Card = styled.form`
  width: 1080px;
  height: 100%;
  box-sizing: border-box;
  margin-top: 22px;
  margin-bottom: 32px;
  background: ${colors.general.white};
  border: 1px solid ${colors.border.poloBlue};;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 11;
  padding: 15px;
  position: relative;
  @media only screen and ${sizes.max991} {
    width: 60vw;
    margin-top: 4vh;
    margin-bottom: 5vh;
    padding: 0;
    border: none;
    border-radius: 0;
    height: unset;
  }
`;

export const LoginWrapper = styled.div`
  position: absolute;
  left: calc(50% - 160px);
  top: 60px;
  z-index: 900;
`;

export const FormWrapper = styled.div`
  width: 320px;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  scrollbar-width: none; /* Hide scrollbar on Firefox */
  -ms-overflow-style: none; /* Hide scrollbar on IE/Edge */
  padding-top: ${props => props.padTop ? 32 : 0}px;
  &::-webkit-scrollbar {
    width: 0; /* Set the width to 0 to hide the scrollbar on Chrome */
  }
  @media only screen and ${sizes.max991} {
    width: 100%;
    overflow-y: scroll;
    padding-bottom: 6vh;
  }
`;

export const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  @media only screen and ${sizes.max991} {
    display: none;
  }
`;

export const BackgroundImageOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  opacity: 50%;
  background-color: ${colors.background.lochmara};
  @media only screen and ${sizes.max991} {
    display: none;
  }
`;

export const InputsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: ${props => props.noMargins ? 0 : 15}px;
  @media only screen and ${sizes.max991} {
    gap: 3.2vw;
    margin-bottom: ${props => props.noMargins ? 0 : 7.8}vw;
  }
`;

export const SizeInputs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  @media only screen and ${sizes.max991} {
    gap: 3.2vw;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  min-width: 1px;
  gap: 4px;
  > input {
    width: 100%;
  }
  @media only screen and ${sizes.max991} {
    gap: 0.8vw;
  }
`;

export const InputTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  ${fontSize(14)}
  line-height: 120%;
  position: relative;
  color: ${colors.text.gray};  
  &:hover {
  .tooltip {
    visibility: visible;
    z-index: 1000; /* or any value higher than other elements */
  }
}
`;

export const Tooltip = styled.div`
  display: flex;
  width: 160px;
  font-style: normal;
  position: absolute;
  top: -12px;
  padding: 4px 4px 4px 4px;
  background-color: gray;
  border-radius: 5px;
  left: 60px;
  visibility: hidden;
  color: ${colors.text.gray};
`;

export const TooltipDesc = styled.span`
   font-size: 12px;
   color: white;
`;

export const ErrorMessage = styled.span`
  width: 100%;
  font-style: normal;
  font-weight: 500;
  ${fontSize(14)}
  line-height: 120%;
  text-align: start;
  color: ${colors.error.sunsetOrange};
`;

export const ErrorMessageDoc = styled.span`
  font-style: normal;
  font-weight: 500;
  ${fontSize(14)}
  text-align: start;
  color: ${colors.error.sunsetOrange};
`;

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-bottom:${props => props.padding ? 10 : 0}px;
`;

export const StillInterested = styled.div`
  height: 24px;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
`;

export const PriceAndPromotionsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
